import GoogleMapsProvider from './mapProvider/googleMapsProvider';

export default class Map {
  google = new GoogleMapsProvider();
}
